import {SummaryModel} from "../../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../../common/entity/permissions.model";
import {ValueAndLabelModel} from "../../../../../../common/model/valueAndLabel.model";

export class PaymentCardReaderSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    name: string;
}

export enum PaymentCardReaderStatus {
    PAYMENT_CARD_READER_STATUS_PAIRED = 'PAYMENT_CARD_READER_STATUS_PAIRED'
}